module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-he.cb946b35.png";